import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { _CostProductionOrderCatalog } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { PrintJson } from '../../../theme/Component/PrintJson';
import { toast } from 'react-toastify';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    idProductionOrder?: any;
    productionOrderDate?: any

}

export const CostProductionOrderEditor = ({ idSelector, onChange, label, returnType = "ID", render, idProductionOrder, productionOrderDate }: Props) => {

    const { instance, lista, setLista } = useDataBean(_CostProductionOrderCatalog)
    const [id, setID] = useState(null);

    const modal = useModal("Costos de Producción WIP", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])

    const setValue = (e: any) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.AccountantIDName == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
        modal.close();
    }


    const getLista = () => {

        instance.getCostProductionOrderConsolidated(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        // { title: 'ID', property: 'IDCostProductionOrder', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'AccountantIDName', visible: true, },
        { title: 'Cuenta Contable', property: 'AccountantIDStr', visible: true, },
        { title: 'Valor Total', property: 'TotalValue', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Costos de Producción WIP"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <PrintJson json={idProductionOrder} />
                <PrintJson json={productionOrderDate} />
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.AccountantIDName) }}></BasicTable>
            </Modal>
        </>
    )
}